import { IPolicy } from 'shared';

import { sanityCheckPolicy } from '../lib/policySanityChecks';

export function usePolicySanityChecks(policy: IPolicy | null) {
  if (!policy) return [];

  return sanityCheckPolicy(policy);
}
